import { useState, useCallback, useEffect } from "react";

const KEY = "jobbkarta_profile_v1";

const EMPTY = { name: "", email: "", phone: "" };

export function loadProfile() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...EMPTY, ...JSON.parse(raw) } : { ...EMPTY };
  } catch {
    return { ...EMPTY };
  }
}

export function useProfile() {
  const [profile, setProfileState] = useState(() => loadProfile());

  const setProfile = useCallback((next) => {
    setProfileState((prev) => {
      const merged = { ...prev, ...next };
      try {
        localStorage.setItem(KEY, JSON.stringify(merged));
      } catch {
        /* ignore quota errors */
      }
      return merged;
    });
  }, []);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setProfileState(loadProfile());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const isComplete = Boolean(profile.name && profile.email);

  return { profile, setProfile, isComplete };
}
